import { initMenuToggle } from './assets/js/menu-toggle.js';

initMenuToggle();
